import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import { toRefs } from 'vue';

import type { NormalizedPerpsPosition } from '@exchange/libs/account/service/src/lib/wss-account-messages';
import { usePositionsListDesktop } from '@exchange/libs/futures/ui/src/lib/useFuturesPositionsList';

import OpenPositionsItem from './OpenPositionsItem.vue';
import DivTable from '../components/DivTable.vue';
import InfoMessageBlock from '../components/InfoMessageBlock.vue';

const tableSortingKey = 'MY_POSITIONS_SORTING';


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenPositionsListDesktop',
  props: {
  authenticatedUser: { type: Boolean, required: true },
  breakpoint: { type: String, required: true },
  dragging: { type: Boolean, required: true },
  marketId: { type: String, required: true },
  showAllMarkets: { type: Boolean, required: true },
  maxLeverage: { type: Number, required: false },
  futuresPositions: { type: Array, required: true },
},
  emits: ['close-position', 'flip-position'],
  setup(__props, { emit: __emit }) {

const props = __props;

const { breakpoint: breakpointRef, marketId } = toRefs(props);

const { desktopHeader } = usePositionsListDesktop(tableSortingKey, breakpointRef);

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DivTable, {
    class: _normalizeClass(["open-positions-list", __props.breakpoint]),
    header: _unref(desktopHeader),
    rows: __props.futuresPositions,
    "sticky-header": true,
    onHeaderChanged: () => {}
  }, {
    default: _withCtx(({ rows }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows as Array<NormalizedPerpsPosition>, (position) => {
        return (_openBlock(), _createBlock(OpenPositionsItem, {
          key: position.instrument_code,
          class: "open-positions-list__row",
          position: position,
          "max-leverage": __props.maxLeverage,
          onClosePosition: _cache[0] || (_cache[0] = (pos) => emit('close-position', pos)),
          onFlipPosition: _cache[1] || (_cache[1] = (pos) => emit('flip-position', pos))
        }, null, 8, ["position", "max-leverage"]))
      }), 128)),
      (!rows.length)
        ? (_openBlock(), _createBlock(InfoMessageBlock, {
            key: 0,
            class: "open-positions-list__info",
            "market-id": _unref(marketId),
            "show-all-markets": __props.showAllMarkets,
            "authenticated-user": __props.authenticatedUser,
            "is-positions": true
          }, null, 8, ["market-id", "show-all-markets", "authenticated-user"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "header", "rows"]))
}
}

})